// extracted by mini-css-extract-plugin
export var videoButton = "VideoButton-module--video-button--M6H0J";
export var videoButtonHide = "VideoButton-module--video-button-hide--xTZFd";
export var videoButtonIcon = "VideoButton-module--video-button-icon--mDNAr";
export var videoButtonIconBlue = "VideoButton-module--video-button-icon-blue--rmrC3";
export var videoButtonIconWhite = "VideoButton-module--video-button-icon-white--Ull2d";